const jednosci = ['', 'jeden', 'dwa', 'trzy', 'cztery', 'pięć', 'sześć', 'siedem', 'osiem', 'dziewięć'];
const nastki = ['dziesięć', 'jedenaście', 'dwanaście', 'trzynaście', 'czternaście', 'piętnaście',
  'szesnaście', 'siedemnaście', 'osiemnaście', 'dziewiętnaście'];
const dziesiatki = ['', '', 'dwadzieścia', 'trzydzieści', 'czterdzieści', 'pięćdziesiąt',
  'sześćdziesiąt', 'siedemdziesiąt', 'osiemdziesiąt', 'dziewięćdziesiąt'];
const setki = ['', 'sto', 'dwieście', 'trzysta', 'czterysta', 'pięćset', 'sześćset',
  'siedemset', 'osiemset', 'dziewięćset'];
const grupy = [
  ['', '', ''],
  ['tysiąc', 'tysiące', 'tysięcy'],
  ['milion', 'miliony', 'milionów'],
  ['miliard', 'miliardy', 'miliardów'],
];

// Wybiera właściwą formę: 1 złoty, 2 złote, 5 złotych
function odmiana(n, [jeden, kilka, wiele]) {
  if (n === 1) return jeden;
  const j = n % 10;
  const d = n % 100;
  if (j >= 2 && j <= 4 && (d < 12 || d > 14)) return kilka;
  return wiele;
}

// Zamienia liczbę 0–999 na słowa
function trojka(n) {
  const s = Math.floor(n / 100);
  const r = n % 100;
  const slowa = [setki[s]];
  if (r >= 10 && r < 20) {
    slowa.push(nastki[r - 10]);
  } else {
    slowa.push(dziesiatki[Math.floor(r / 10)], jednosci[r % 10]);
  }
  return slowa.filter(Boolean).join(' ');
}

export function liczbaSlownie(n) {
  if (n === 0) return 'zero';
  const czesci = [];
  let i = 0;
  while (n > 0) {
    const t = n % 1000;
    if (t > 0) {
      // "tysiąc", a nie "jeden tysiąc"
      const liczba = i > 0 && t === 1 ? '' : trojka(t);
      const nazwa = i > 0 ? odmiana(t, grupy[i]) : '';
      czesci.unshift([liczba, nazwa].filter(Boolean).join(' '));
    }
    n = Math.floor(n / 1000);
    i++;
  }
  return czesci.join(' ');
}

export function kwotaSlownie(kwota) {
  const wszystkieGrosze = Math.round(Math.abs(Number(kwota) || 0) * 100);
  const zl = Math.floor(wszystkieGrosze / 100);
  const gr = wszystkieGrosze % 100;
  return `${liczbaSlownie(zl)} ${odmiana(zl, ['złoty', 'złote', 'złotych'])} ` +
         `${liczbaSlownie(gr)} ${odmiana(gr, ['grosz', 'grosze', 'groszy'])}`;
}
